module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/coupon-icon.15af341e.svg";